export default __webpack_public_path__ + "static/icon-20-5-f801916a50f9985e353ce8fa5af8a3b5.png";